import React, { useState } from "react";
import "../../css/whychooseus.css";
import who from "../../image/who.webp";
import iso from "../../image/iso.webp";
import gmp from "../../image/gmp.webp";
import { useNavigate } from "react-router-dom";
function WhyChooseUs({ setShowModal }) {
  const [result, setResult] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setResult("");

    const formData = new FormData(event.target);
    const dataObj = Object.fromEntries(formData.entries());
    dataObj.subject = "New Enquiry from Why Choose Us Section";

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataObj)
      });

      const data = await response.json();

      if (data.success) {
        navigate("/thank-you");
        event.target.reset();
      } else {
        console.log("Error", data);
        setResult("Something went wrong while submitting your enquiry. Please try again.");
      }
    } catch (error) {
      setResult("Something went wrong while submitting your enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-3 py-lg-5" style={{ backgroundColor: "#fdfdfd" }} id="certificate">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left Column: Why Choose Us */}
          <div className="col-lg-6 pe-lg-5">
            <div className="mb-4">
              <div className="d-inline-flex align-items-center gap-2 mb-2">
                <div style={{ width: "40px", height: "3px", backgroundColor: "#e86229", borderRadius: "2px" }}></div>
                <h6 className="fw-bold text-uppercase mb-0" style={{ color: "#e86229", letterSpacing: "2px" }}>
                  Why Choose Us
                </h6>
              </div>
              <h2 className="fw-bold display-6 mb-3" style={{ color: "#1a2f55", fontFamily: "'Georgia', serif" }}>
                Your Trusted Partner for Pharma Growth
              </h2>
              <p className="text-muted" style={{ lineHeight: "1.8" }}>
                We are committed to delivering <strong>premium-quality pharmaceutical products</strong> with a strong focus on safety, reliability, and patient satisfaction. By combining <strong>innovation, affordability, and advanced quality standards</strong>, we provide trusted healthcare solutions that make a meaningful difference across the nation.
                <span className="d-none d-md-inline"> Our commitment to premium quality, innovation-driven solutions, affordable healthcare, strict quality standards, and a customer-focused approach enables us to build lasting trust and deliver value to every customer we serve. We continuously strive to improve our products, processes, and services to meet evolving healthcare needs and create a healthier future for all.</span>
              </p>
            </div>
            <div className="row g-3 mt-4 align-items-center justify-content-center justify-content-lg-start">
              <div className="col-4">
                <div className="badge-wrapper p-3 bg-white rounded-3 shadow-sm border border-light h-100 d-flex align-items-center justify-content-center">
                  <img src={who} alt="WHO Certified" className="img-fluid badge-img" />
                </div>
              </div>
              <div className="col-4">
                <div className="badge-wrapper p-3 bg-white rounded-3 shadow-sm border border-light h-100 d-flex align-items-center justify-content-center">
                  <img src={iso} alt="ISO Certified" className="img-fluid badge-img" />
                </div>
              </div>
              <div className="col-4">
                <div className="badge-wrapper p-3 bg-white rounded-3 shadow-sm border border-light h-100 d-flex align-items-center justify-content-center">
                  <img src={gmp} alt="GMP Certified" className="img-fluid badge-img" />
                </div>
              </div>
            </div>

            <div className="mt-5">
              <button className="btn px-4 py-2 text-white fw-bold shadow-sm rounded-pill" style={{ backgroundColor: "#e86229" }} onClick={() => setShowModal(true)}>
                Book a Free Consultation
              </button>
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="col-lg-6">
            <div className="p-4 bg-white shadow-sm rounded-4">
              <div className="text-center mb-4 pb-2">

                <h3
                  className="mb-2 text-uppercase fs-5 fs-md-3"
                  style={{
                    background: 'linear-gradient(90deg, #e86229, #ff7a00)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    letterSpacing: '1px',
                    textShadow: '0px 5px 15px rgba(232, 98, 41, 0.2)',
                    fontWeight: '900',
                  }}
                >
                  Get Product & Price List
                </h3>
                <p className="text-muted fw-bold mb-3" style={{ letterSpacing: '0.5px', fontSize: '12px' }}>REQUEST OUR COMPREHENSIVE CATALOGUE</p>
                <div style={{ width: "80px", height: "4px", background: "linear-gradient(90deg, #e86229, #c14413)", margin: "0 auto", borderRadius: "2px" }}></div>
              </div>
              <form className="hero-form" onSubmit={onSubmit}>
                <div className="mb-3">
                  <input type="text" name="name" className="form-control" placeholder="Your Name*" required />
                </div>
                <div className="mb-3">
                  <input type="email" name="email" className="form-control" placeholder="Email" pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" title="Please enter a valid email address" />
                </div>
                <div className="mb-3">
                  <input type="tel" name="phone" className="form-control" placeholder="Phone Number*" pattern="[0-9]{10}" maxLength="10" minLength="10" title="Please enter a valid 10-digit phone number" required />
                </div>
                {/* <div className="mb-3">
                      <label className="form-label text-primary-dark fw-bold small mb-2" style={{ letterSpacing: '0.5px' }}>Choose Your Product Range</label>
                      <select className="form-select" name="product_range">
                        <option>General Medicine</option>
                        <option>Derma Range</option>
                        <option>Gynae Range</option>
                        <option>Ortho Range</option>
                      </select>
                    </div> */}
                <div className="mb-3">
                  <input type="text" name="city" className="form-control" placeholder="Your City*" required />
                </div>
                <div className="mb-4">
                  <textarea name="message" className="form-control" rows="2" placeholder="Message"></textarea>
                </div>
                <button type="submit" disabled={isSubmitting} className="btn px-4 py-2 text-white border-0 fw-bold rounded-2 form-submit-btn w-100 mb-2" style={{ backgroundColor: "#e86229" }}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                {result && <div className="text-center small mt-2 fw-bold text-danger">{result}</div>}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
